module.exports = __webpack_public_path__ + "img/ticket15.6ed565b4.png";